// extracted by mini-css-extract-plugin
export default {"container":"FileViewerModal_container__65PrB"};